// Network/config.js

const isProduction = 1;

const PRODUCTION_ENDPOINT_V1 = "https://api-onewq.bcsisolutions.com/v1";
const STAGING_ENDPOINT_V1 = "https://api-staging-onewq.bcsisolutions.com/v1";
// const PRODUCTION_ENDPOINT_V2 = "https://sandbox-api.danileeshelpinghnds.org/v2";

// New base URL for admin API
// const ADMIN_API_ENDPOINT = "http://18.117.70.32:3001/v1";

export const ENDPOINT = isProduction ? PRODUCTION_ENDPOINT_V1 : STAGING_ENDPOINT_V1;

// export const ENDPOINT_V2 = PRODUCTION_ENDPOINT_V2;
// export const ADMIN_ENDPOINT = ADMIN_API_ENDPOINT;

export const Urls = {
  login: "login/admin",
  forgetPassword: "forgot-password",
  updatePassword: "update-password",
  getJobs: "get-jobs/admin",
  businesses: "get-businesses/admin",
  businessDeatils: "get-business-details/admin",
  getJobDetails: "get-job-details/admin",
  editCustomer: "edit-customer-details/admin",
  editBusiness: "edit-business-details/admin",
  getAdminCustomers: "get-customers/admin",
  locations: "usa-states-cities",
  catagory: "catagory",
  uploadFiles: "upload-files",
  deactivateBusiness: "deacticate-business/admin",
  verifyEmail: "verify-email/email/admin"
};
